import { login as loginToNode } from '@pba/client-auth';
import type { AuthenticationResponseJSON } from '@simplewebauthn/browser';
import { type NodeLogin, createNodeLogin } from 'models';
import { useMutation } from 'query';

type LoginData =
  | {
      // eslint-disable-next-line @typescript-eslint/naming-convention -- TODO: Needs to be fixed later
      relyingPartyID?: string;
      response?: AuthenticationResponseJSON;
      strategy: 'passkey';
      token: string;
    }
  | {
      accessToken: string;
      strategy: 'pba';
    }
  | {
      email: string;
      password: string;
      strategy: 'password';
    }
  | {
      password?: string;
      strategy: 'code';
      token: string;
    };

const defaultMutateOnError = () => {
  // Do nothing
  // This mutation is used within other mutation that handle error already
};

export const useLoginToNodeMutation = () =>
  useMutation<NodeLogin, LoginData>({
    defaultMutateOnError,
    async mutationFn(data: LoginData) {
      const { data: responseData } = await loginToNode({
        body: data,
      });

      return createNodeLogin(responseData);
    },
  });
